import Skeleton from 'react-loading-skeleton';

const AddressFormSkeleton = () => {
  return (
    <div className="mx-auto w-full max-w-3xl p-4">
      <section className="rounded-md bg-white-100 p-4 bp2:p-6">
        <Skeleton count={4} className="my-4" height={32} />
        <Skeleton
          count={1}
          className="my-4"
          width="48%"
          inline={true}
          height={32}
          style={{ marginRight: '2%' }}
        />
        <Skeleton
          count={1}
          className="my-4"
          width="48%"
          inline={true}
          height={32}
          style={{ marginLeft: '2%' }}
        />
        <Skeleton count={2} className="my-4" height={32} />
      </section>
    </div>
  );
};

export default AddressFormSkeleton;
